import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { createContext, useContext, useState } from "react";
// import logo2 from "../assets/img/loader2.gif";
// import logo3 from "../assets/img/loader5.gif";
// import logo4 from "../assets/img/loader6.gif";

const LoadingContext = createContext({ loading: false, setLoading: null });

export function LoadingProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const value = { loading, setLoading };
  return (
    <LoadingContext.Provider value={value}>
      {children}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1600 }}
        open={loading}
      >
        {" "}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress style={{'color': 'blue'}} ></CircularProgress>
          <div>
            {/* <img src={logo2} width="125" height="125"/> */}
            {/* <img src={logo3} width="300" height="300"/> */}
            {/* <img src={logo4} width="125" height="125"/> */}
            </div>
          <div>Please wait ...</div>
          {/* <div style={{'color': '#201A75'}}>Please wait....</div> */}
        </Box>
      </Backdrop>
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}
